"use client";

export default function GlobalError() {
  return (
    <html lang="ko" className="dark">
      <body>
        <main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
          <div className="max-w-sm text-center">
            <p className="text-sm font-medium text-muted-foreground">오류</p>
            <h1 className="mt-3 text-2xl font-semibold">문제가 발생했습니다</h1>
            <p className="mt-3 text-sm text-muted-foreground">
              잠시 후 다시 시도해 주세요.
            </p>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- 치명 오류 경계: 전체 새로고침(<a>)이 복구에 안전. Link 의 클라 네비는 깨진 상태로 재진입할 위험 */}
            <a
              href="/"
              className="mt-6 inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
            >
              홈으로 이동
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
